import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import {
  promotionGetInicisDataByCode,
  savePromotionInicisBillByCode,
} from "src/service/pay";
import { IPromotionGetInicisDataRes } from "src/service/types/pay.type";
import { insertInicisModule } from "src/utils/pay/insertInicisModule";
import { useRouter } from "src/hooks/useRouter";
import { productNameMap } from "src/mocks/useProductInfo";
import { notifyError } from "src/components/Common/Toast";

// 비로그인 사용자 카드 결제 페이지 (URL의 프로모션 코드 기준으로 이니시스 결제정보 세팅)
const GuestPayCard = () => {
  const { t } = useTranslation();
  const { lang } = useRouter();
  const { promotionCode } = useParams<{ promotionCode: string }>();
  const [inicisData, setInicisData] = useState<IPromotionGetInicisDataRes>();
  const [isError, setIsError] = useState(false);

  const billPrint_msg = t(
    "siteManagement.paymentHistory.bill.detail.includeVat"
  );

  useEffect(() => {
    insertInicisModule();
    if (!promotionCode) return;
    promotionGetInicisDataByCode(promotionCode)
      .then(setInicisData)
      .catch(() => setIsError(true));
  }, [promotionCode]);

  // 이니시스 데이터 저장이 성공해야 결제창 호출
  const onClickPurchase = async () => {
    if (!inicisData || !promotionCode) return;
    try {
      await savePromotionInicisBillByCode({
        orderId: inicisData.oid,
        promotionCode,
        totalPrice: inicisData.price,
      });
    } catch (error) {
      // basicAxios는 인터셉터가 없어 응답 바디({ errorCode, errorMessage })를 직접 꺼내서 안내
      const { errorMessage } =
        (error as AxiosError<{ errorCode?: string; errorMessage?: string }>)
          .response?.data ?? {};
      notifyError(
        errorMessage ?? t("결제 정보 저장에 실패했습니다. 다시 시도해주세요.")
      );
      return;
    }
    // @ts-expect-error
    window.INIStdPay?.pay("inicisForm");
  };

  if (!promotionCode || isError) {
    return (
      <div style={{ textAlign: "center", margin: "250px 0" }}>
        {t("유효하지 않은 결제 링크입니다.")}
      </div>
    );
  }

  return (
    <div>
      {/* 이니시스 PC 결제 폼 */}
      <form
        className="inicisForm"
        id="inicisForm"
        name="inicisForm"
        method="POST"
        style={{ display: "none" }}
      >
        <input name="version" readOnly value="1.0" />
        <input name="mid" readOnly value={inicisData?.mid} />
        <input
          name="goodname"
          readOnly
          required={true}
          value={
            productNameMap[inicisData?.product as string] ??
            inicisData?.product
          }
        />
        <input name="oid" readOnly value={inicisData?.oid} />
        <input name="price" readOnly value={inicisData?.price} />
        <input name="currency" readOnly value="WON" />
        <input name="buyername" readOnly value={inicisData?.buyerName} />
        <input name="buyertel" readOnly value="010-0000-0000" />
        <input name="buyeremail" readOnly value={inicisData?.buyerEmail} />
        <input name="timestamp" readOnly value={inicisData?.timestamp} />
        <input name="signature" readOnly value={inicisData?.signature} />
        <input
          name="returnUrl"
          readOnly
          value={
            window.location.origin +
            "/eco-cloud/wapi/cloud/pay/promotion/returnUrl/" +
            inicisData?.oid
          }
        />
        <input name="mKey" readOnly value={inicisData?.mKey} />
        <input name="gopaymethod" readOnly value="Card" />
        <input name="acceptmethod" readOnly value="below1000:billauth(card)" />
        <input name="billPrint_msg" readOnly value={billPrint_msg} />
        <input name="languageView" readOnly value={lang} />
        <input name="charset" readOnly value="UTF-8" />
        <input name="merchantData" readOnly value="" />
        <input name="tax" readOnly value="0" />
        <input name="taxfree" readOnly value="0" />
        <input
          type="hidden"
          readOnly
          name="closeUrl"
          value={window.location.href}
        />
      </form>

      <button
        onClick={(e) => {
          e.preventDefault();
          onClickPurchase();
        }}
        disabled={!inicisData}
        className="btn btn-40 width w-100p mg mt-20 pd py-10"
        style={{
          width: "auto",
          margin: "250px auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#3182f6",
          color: "#ffffff",
        }}
      >
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            className="mg mr-10"
            style={{ width: "16px", height: "12px" }}
            src="/resources/images/card.png"
          />
          {t("체크카드 또는 신용카드 결제하기")}
        </span>
      </button>
    </div>
  );
};

export default GuestPayCard;
